import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../../actions/user.action";
import {
  deleteAnnonce,
  addToFavorites,
  removeFromFavorites,
} from "../../actions/annonce.action";
import { dateParser } from "../Utils";
import AnnonceSlider from "./AnnnonceSLider";
import { FaRegStar, FaStar } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { renderAnnonceDetails } from "./RenderAnnonceDetails";
import { renderAnnoncePrice } from "./RenderAnnoncePrix";
import { RenderAnnonceImage } from "./RenderAnnonceImage";

const CarteAnnonces = ({ annonce, utilisateurId }) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.userReducer?.users || {});
  const userData = useSelector((state) => state.userReducer);
  const userId = useSelector((state) => state.userReducer._id);

  const utilisateur = users[utilisateurId] || null;
  const categoriesNoDescription = [
    "voiture",
    "logement",
    "terrain",
    "formation",
    "travail",
  ];

  useEffect(() => {
    if (Object.keys(users).length === 0) {
      dispatch(getUsers());
    }
  }, [users, dispatch]);

  const handleDelete = () => {
    if (window.confirm("Voulez-vous vraiment supprimer cette annonce ?")) {
      dispatch(deleteAnnonce(annonce._id));
    }
  };

  const isFavori = annonce.favoris?.includes(userId);

  const toggleFavorite = () => {
    if (isFavori) {
      dispatch(removeFromFavorites(userId, annonce._id));
    } else {
      dispatch(addToFavorites(userId, annonce._id));
    }
  };

  if (!utilisateur) return <p>Chargement des infos utilisateur...</p>;

  return (
    <div className="carteAnnonce">
      <div className="zoneAnnonce">
        <div className="infoAnnonce">
          <h2>
            Annonce créée par : <span>{utilisateur.pseudo}</span>
          </h2>
          <h3>Publiée le {dateParser(annonce.datePublication)}</h3>
          <span
            title={isFavori ? "retirer des favoris" : "ajouter aux favoris"}
            onClick={toggleFavorite}
            className="star-button"
          >
            {isFavori ? <FaStar /> : <FaRegStar />}
          </span>
          {(userId === annonce.utilisateur || userData?.isAdmin) && (
            <span
              className="delete-button"
              onClick={handleDelete}
              title="Supprimer l'annonce"
            >
              <FaTrash style={{ color: "red", cursor: "pointer", marginRight: "10px" }} />
            </span>
          )}
        </div>

        <div className="divCarteAnnonce">
          <h1>{annonce.titre}</h1>
          <div className="topPart">
            <div className="zoneInfos">{renderAnnonceDetails(annonce)}</div>
            <div className="div-img">
              {RenderAnnonceImage(annonce)}
            </div>
          </div>

          {categoriesNoDescription.includes(annonce.categorie) && (
            <div className="description">
              <p>Description:</p>
              <div>
                <p className="text-description">{annonce.description}</p>
              </div>
            </div>
          )}

          {userId != null ? (
            <div className="bottomPart">
              {renderAnnoncePrice(annonce)}
              {utilisateur?.phone ? (
                <h2 className="tel">Tel. : {utilisateur.phone}</h2>
              ) : (
                <p>Pas de coordonnées fournies</p>
              )}
            </div>
          ) : (
            <p>Informations supplémentaires : merci de vous connecter.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CarteAnnonces;
